import React from 'react';

export default function FormField({ label, error, hint, children, required, className = '' }) {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label className="label">
          {label}{required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
      {children}
      {hint && !error && (
        <p className="mt-1 text-xs text-slate-400">{hint}</p>
      )}
      {error && (
        <p className="mt-1 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}

export function Input({ error, className = '', ...props }) {
  return (
    <input
      className={`input ${error ? 'border-red-400 focus:border-red-500 focus:ring-red-400' : ''} ${className}`}
      {...props}
    />
  );
}

export function Textarea({ error, className = '', ...props }) {
  return (
    <textarea
      className={`input min-h-[100px] resize-y ${error ? 'border-red-400 focus:border-red-500 focus:ring-red-400' : ''} ${className}`}
      {...props}
    />
  );
}

export function Select({ error, children, className = '', ...props }) {
  return (
    <select
      className={`input ${error ? 'border-red-400 focus:border-red-500 focus:ring-red-400' : ''} ${className}`}
      {...props}
    >
      {children}
    </select>
  );
}
